<div class="page_responsive_1 outer_card_1 ">
    <div class="card">
        <div class="card-body" style="padding: 0;">
            <div class="row my-2">

                <div class="col-lg-3 col-sm-3 col-md-3 overlay">
                    <app-dropdown class="custom-dropdown" [options]="states" [(ngModel)]="selectedState" (click)= getSelected()
                    placeholder= {{displayBranch}}  optionLabel="name"></app-dropdown>
                </div>

                <div class="col-lg-5 col-sm-5 col-md-5"></div>

                <div class="col-lg-2 col-sm-2 col-md-2 overlay">
                    <p-datepicker #calendar class="custom-calendar" [(ngModel)]="rangeDates" (onSelect)="onSelect()" [maxDate]="maxDate"
                    [showIcon]="true" iconDisplay="input"   placeholder="Filter Range" selectionMode="range" [readonlyInput]="false" inputId="range" dateFormat="dd/mm/yy">
                    </p-datepicker>
                </div>

                <div class="col-lg-2 col-sm-2 col-md-2 overlay">
                    <p-datepicker class="custom-calendar" [(ngModel)]="selectedDate" placeholder="Select Month"
                    [showIcon]="true" iconDisplay="input"  view="month" dateFormat="MM yy" [readonlyInput]="false" inputId="monthpicker"></p-datepicker>

                </div>

            </div>
        </div>
    </div>

</div>

<div class="outer_card">
    <div class="card order-container">
        <!-- card-body -->
        <div class="">
            <div class="row order-title-container">
                <span class="col-lg-6 col-sm-6 col-md-6 card-title title_header ">Order Details</span>
            </div>

            <div class="row">
                <div class="col-lg-3 col-sm-3 col-md-3">
                    <div class="card card_style_bs_order">
                        <div class="card-body ">
                            <div class="row">
                                <div class="col-9 order_font">{{totalOrders}}

                                    <span class="font_size_od">
                                        <span *ngIf="incrementValue" class="graph-up"><i class='bx bx-trending-up'></i>
                                            + 2.4%</span>
                                        <span *ngIf="!incrementValue"><i class='bx bx-trending-down'></i>- 2.4%</span>
                                    </span>
                                    <div>
                                        <p>Total Orders</p>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-sm-3 col-md-3 text-right">
                                    <i class='icon_color bx bxl-dropbox bx-sm'></i>
                                </div>
                            </div>
                            <!-- <div class="row"> -->
                            <!-- <div class="row">

                            </div> -->
                            <!-- <div class="row"> -->
                            <!-- <div class="col-lg-6 col-sm-6 col-md-6 font_size_od">
                                    <span *ngIf="incrementValue" style="margin-right: 10px;"><i
                                            class='bx bx-trending-up'></i> + 2.4%</span>
                                    <span *ngIf="!incrementValue" style="margin-right: 10px;"><i
                                            class='bx bx-trending-down'></i>- 2.4%</span>
                                </div> -->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-3 col-md-3">
                    <div class="card card_style_bs_order">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-9 order_font">{{inprogressOrders}}
                                    <span class="font_size_od">
                                        <span *ngIf="incrementValue" class="graph-up"><i class='bx bx-trending-up'></i>
                                            + 2.4%</span>
                                        <span *ngIf="!incrementValue"><i class='bx bx-trending-down'></i>- 2.4%</span>
                                    </span>
                                    <div>
                                        <p>In Progress</p>
                                    </div>


                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right">
                                    <i class='icon_color bx bxs-time-five bx-md'></i>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div>
                                    <p >In Progress</p>
                                </div>

                            </div> -->

                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-3 col-md-3">
                    <div class="card card_style_bs_order">
                        <div class="card-body ">
                            <div class="row">
                                <div class="col-9 order_font">{{completedOrders}}

                                    <span class="font_size_od">
                                        <span *ngIf="incrementValue" class="graph-up"><i class='bx bx-trending-up'></i>
                                            + 2.4%</span>
                                        <span *ngIf="!incrementValue"><i class='bx bx-trending-down'></i>- 2.4%</span>
                                    </span>
                                    <div style="padding-right: 0;">
                                        <p>Completed Orders</p>
                                    </div>

                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right">
                                    <i class='icon_color bx bxs-package bx-md'></i>
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div style="padding-right: 0;">
                                    <p >Completed Orders</p>
                                </div>
                            </div> -->


                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-sm-3 col-md-3">
                    <div class="card card_style_bs_order">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-9 order_font">{{canceledOrder}}
                                    <span class="font_size_od">
                                        <span *ngIf="incrementValue" class="graph-up"><i class='bx bx-trending-up'></i>
                                            + 2.4%</span>
                                        <span *ngIf="!incrementValue"><i class='bx bx-trending-down'></i>- 2.4%</span>
                                    </span>
                                    <div>
                                        <p>Cancelled Orders</p>
                                    </div>
                                </div>
                                <div class="col-lg-3 col-sm-3 col-md-3 text-right">
                                    <!-- <img src="../../../assets/img/Vector.png" height="25" class="logo_style_0"> -->
                                    <i class='icon_color bx bxs-box bx-md'></i>
                                    <!-- <i class='bx '></i> -->
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div>
                                    <p >Cancelled Orders</p>
                                </div>

                            </div> -->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>